'use client';

import { Icon } from '@iconify/react/dist/iconify.js';
import { Box, Container, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { m } from 'framer-motion';
import { MotionContainer, varBounce } from 'src/components/animate';
import { Image } from 'src/components/image';
import { BUS_AKAP_FACILITIES } from 'src/utils/consts';

export default function Page() {
  return (
    <Box>
      <Box
        sx={{
          width: '100%',
          borderRadius: {
            xs: '0px 0px 20px 20px',
            md: '0px 0px 50px 50px',
          },
          borderBottom: '5px solid var(--secondary-main, #FEFE01)',
          background:
            'var(--gradient-primary-bold, linear-gradient(135deg, var(--primary-main, #11BB18) 0%, var(--primary-dark, #007867) 100%))',
          boxShadow:
            'var(--color-x, 0px) var(--color-y, 8px) var(--color-blur, 16px) var(--color-spread, 0px) var(--primary-24, rgba(0, 167, 111, 0.24))',
        }}
      >
        <Box
          sx={{
            width: '100%',
            overflow: 'hidden',
            '&::after': {
              content: '""',
              position: 'absolute',
              top: { xs: 0, md: '10px' },
              right: '0px',
              width: '600px',
              height: '600px',
              backgroundImage: 'url("/logo/logo-single.png")',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              opacity: 0.05,
              zIndex: 2,
            },
          }}
        >
          <Container sx={{ py: '40px' }}>
            <Typography variant="h2" color="secondary">
              Bus AKAP
            </Typography>
          </Container>
        </Box>
        <Container
          sx={{
            position: 'relative',
            height: {
              xs: 'calc(20vh)',
              sm: 'calc(60vh)',
            },
            paddingBottom: '16px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <MotionContainer
            sx={{
              bottom: '-100px',
              position: 'absolute',
              width: '80%',
              zIndex: 88,
            }}
          >
            <Box
              component={m.img}
              variants={varBounce('inLeft')}
              src="/assets/images/image-bus-akap.webp"
              alt="Bus Akap Puspa Jaya"
            />
          </MotionContainer>
        </Container>
      </Box>
      <div className="py-[150px]">
        <Container>
          <div className="flex flex-col gap-[38px] md:gap-[78px] mb-[78px]">
            <div className="flex flex-col gap-[28px]">
              <Typography variant="h3" textAlign="center">
                Fasilitas Bus Puspa Jaya Antar Kota Antar Provinsi (AKAP)
              </Typography>
              <Typography variant="h5" textAlign="center">
                Armada yang melayani adalah Bus Reguler Kelas Eksekutif dengan fasilitas sebagai
                berikut:
              </Typography>
            </div>
            <Grid container spacing="20px">
              {BUS_AKAP_FACILITIES.map((e) => (
                <Grid size={{ xs: 4, md: 2 }}>
                  <Paper
                    elevation={4}
                    sx={{
                      xs: '10px',
                      md: '20px',
                      aspectRatio: '1/1',
                    }}
                  >
                    <div className="flex flex-col justify-center items-center w-full h-full gap-[4px]">
                      <Icon icon={e.icon} width="30%" />
                      <Typography variant="h6" textAlign="center">
                        {e.title}
                      </Typography>
                    </div>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </div>
          <div className="flex flex-col gap-[38px] md:gap-[78px]">
            <Typography variant="h3" textAlign="center">
              Interior dan Denah Kursi
            </Typography>
            <div className="flex flex-col md:flex-row md:justify-center items-stretch gap-[16px]">
              <div className="grow">
                <Image
                  sx={{
                    borderRadius: {
                      xs: '10px',
                      md: '20px',
                    },
                  }}
                  src="/assets/images/image-facility-1.webp"
                  alt="Fasilitas kursi pada bus AKAP Puspajaya"
                />
              </div>
              <div className="grow">
                <Image
                  sx={{
                    borderRadius: {
                      xs: '10px',
                      md: '20px',
                    },
                  }}
                  src="/assets/images/image-facility-2.webp"
                  alt="Fasilitas kursi pada bus AKAP Puspajaya"
                />
              </div>
              <div className="grow-0">
                <Paper
                  elevation={4}
                  sx={{
                    width: {
                      xs: '100%',
                      md: '300px',
                    },
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    borderRadius: {
                      xs: '10px',
                      md: '20px',
                    },
                  }}
                >
                  <div className="p-[18px] flex flex-col items-center gap-[16px]">
                    <Typography variant="h5">Denah Kursi</Typography>
                    <Image
                      sx={{
                        width: '160px',
                        borderRadius: {
                          xs: '10px',
                          md: '20px',
                        },
                      }}
                      src="/assets/images/image-denah-kursi-bus-akap-puspajaya.png"
                      alt="Fasilitas kursi pada bus AKAP Puspajaya"
                    />
                  </div>
                </Paper>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </Box>
  );
}
